import { Button } from 'features/components/Button';
import { Dialog } from 'features/entry-form-v2/component/Dialog';
import { useLanguage } from 'features/hooks/useLanguage';
import { CircleAlert } from 'lucide-react';
import { LanguageType } from 'types/enums';

interface Props {
	open: boolean;
	onClose: () => void;
}

export const CodelistLocationDialog = ({ open, onClose }: Props) => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<Dialog open={open} onClose={onClose} title={translation.title}>
			<div className="w-[600px] h-[620px] flex flex-col gap-4">
				<p className="text-base">{translation.description}</p>

				<CodelistWarning />

				<img
					className="mt-6 w-[85%] object-cover self-center"
					src="/img/codelist-changelog/open-codelist.gif"
					alt={translation.imgAlt}
				/>

				<div className="flex justify-end self-end">
					<Button text="Close" onClick={onClose} />
				</div>
			</div>
		</Dialog>
	);
};

export const CodelistWarning = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<div className="flex gap-2 items-center bg-warning-200/25 rounded-md overflow-hidden">
			<div className="bg-warning-200 px-4 self-stretch flex items-center">
				<CircleAlert className="size-6 text-warning-800" />
			</div>

			<p className="text-base font-semibold text-warning-800 py-4 px-1">
				{translation.warning}
			</p>
		</div>
	);
};

export const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Storing personal identifiable information',
		description:
			'You may store personal identifiable information in the sidebar when you create or update an entry.',
		warning: 'Personal identifiable information should not be stored as variables',
		imgAlt: 'Codelist location'
	},

	[LanguageType.Norwegian]: {
		title: 'Lagring av personlig identifiserbar informasjon',
		description:
			'Du kan lagre personlig identifiserbar informasjon i sidemenyen etter at du har opprettet en oppføring.',
		warning: 'Personlig identifiserbar informasjon skal ikke lagres som variabler',
		imgAlt: 'Kodelistplassering'
	}
};
